import { eMode } from "../../../content/enum";
import { IDmMucHocPhiTheoCTDTCopyRequest } from "../../../model/request/category/dmMucHocPhiTheoCTDTCopyRequest";
import { CTDT_TINH_CHATS } from "../../../model/respone/category/IDmMucHocPhiTheoCTDT";
import { IDmMucHocPhiTheoCTDTActionTypes } from "../../action-types/category/IDmMucHocPhiTheoCTDTActions";
import { IDmMucHocPhiTheoCTDTReducer } from "../../reducer-model/category/IDmMucHocPhiTheoCTDTReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IDmMucHocPhiTheoCTDTReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mons: [],
  ctdts: [],
  modeEdit: eMode.xem,
  request: {
    id_dt: 0,
    hoc_ky: 0,
    nam_hoc: "",
    ky_dang_ky: 0,
    id_doi_tuong: 0,
    dot_tuyen_sinh: 0,
    id_he: 0,
    khoa_hoc: 0,
    id_nganh: 0,
    search_key: "",
  },
};

export const mucHocPhiTheoCTDTReducer = (
  state: IDmMucHocPhiTheoCTDTReducer = iniState,
  action: IDmMucHocPhiTheoCTDTActionTypes,
): IDmMucHocPhiTheoCTDTReducer => {
  switch (action.type) {
    case "MUC_HOC_PHI_THEO_CTDT_LOAD_CTDTS_SUCCESS":
      return { ...state, ctdts: action.payload };

    case "MUC_HOC_PHI_THEO_CTDT_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "MUC_HOC_PHI_THEO_CTDT_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mons: action.payload,
      };
    case "MUC_HOC_PHI_THEO_CTDT_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_HOC_PHI_THEO_CTDT_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_HOC_PHI_THEO_CTDT_SAVE_SUCCESS": {
      const mons = state.mons.map((m) => ({ ...m }));
      action.payload.forEach((r) => {
        const m = mons.find((x) => x.id_mon === r.id_mon);
        if (!m) return;
        const tc = CTDT_TINH_CHATS.find((t) => t.hoc_lai === r.hoc_lai);
        if (!tc) return;
        if (r.so_tien < 0) {
          m[`id_${tc.key}`] = null;
          m[`so_tien_${tc.key}`] = null;
        } else {
          m[`id_${tc.key}`] = r.id;
          m[`so_tien_${tc.key}`] = r.so_tien;
        }
      });
      return { ...state, status: eReducerStatusBase.is_completed, mons };
    }
    case "MUC_HOC_PHI_THEO_CTDT_SAVE_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_HOC_PHI_THEO_CTDT_UPDATE_STATUS":
      return { ...state, status: action.payload };
    case "MUC_HOC_PHI_THEO_CTDT_CHANGE_REQUEST":
      return { ...state, request: action.payload };

    case "MUC_HOC_PHI_THEO_CTDT_LOCK_START":
    case "MUC_HOC_PHI_THEO_CTDT_UNLOCK_START":
      return {
        ...state,
        request: action.payload,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_HOC_PHI_THEO_CTDT_LOCK_SUCCESS":
    case "MUC_HOC_PHI_THEO_CTDT_UNLOCK_SUCCESS":
      // Danh sách sẽ được saga làm mới qua LOAD_START (payload là dòng đơn giá thô, không phải môn pivot).
      return { ...state, status: eReducerStatusBase.is_saved };
    case "MUC_HOC_PHI_THEO_CTDT_LOCK_ERRR":
    case "MUC_HOC_PHI_THEO_CTDT_UNLOCK_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_HOC_PHI_THEO_CTDT_SHOWHIDE_COPY_MODAL":
      return {
        ...state,
        isShowModalCopy: action.payload,
        requestCopy: {} as IDmMucHocPhiTheoCTDTCopyRequest,
      };
    case "MUC_HOC_PHI_THEO_CTDT_COPY_CHANGE_REQUEST":
      return {
        ...state,
        requestCopy: { ...state.requestCopy, ...action.payload },
      };
    case "MUC_HOC_PHI_THEO_CTDT_COPY_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "MUC_HOC_PHI_THEO_CTDT_COPY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
        isShowModalCopy: false,
      };
    case "MUC_HOC_PHI_THEO_CTDT_COPY_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };

    case "MUC_HOC_PHI_THEO_CTDT_CHANGE_MODE_EDIT":
      return { ...state, modeEdit: action.payload };

    default:
      return state;
  }
};
